export default "__VITE_ASSET__D9V26R3s__"